import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

export type HeaderDesignMode = 'default' | 'blanks' | 'settings' | 'users' | 'job-form';
export type HeaderAction = 'inviteUser' | 'createNewBlank' | 'importBlank' | 'importSettings' | 'exportSettings';

export interface PageHeaderConfig {
    mode: HeaderDesignMode;
}

const DEFAULT_CONFIG: PageHeaderConfig = {
    mode: 'default',
};

@Injectable({ providedIn: 'root' })
export class PageHeaderService {
    private readonly _config = signal<PageHeaderConfig>(DEFAULT_CONFIG);
    readonly config = this._config.asReadonly();
    readonly actions$ = new Subject<HeaderAction>();

    set(config: Partial<PageHeaderConfig>): void {
        this._config.update((current) => ({ ...current, ...config }));
    }

    reset(): void {
        this._config.set(DEFAULT_CONFIG);
    }

    triggerAction(action: HeaderAction): void {
        this.actions$.next(action);
    }
}
